/** Build-time settings, one set per environment (see web/.env.*). */
export const config = {
  env: import.meta.env.VITE_APP_ENV,
  apiUrl: `${import.meta.env.VITE_API_URL}/api/v1`,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  },
  /** The phone app's link scheme: staging builds use their own so both can be installed. */
  appScheme: import.meta.env.VITE_APP_SCHEME || (import.meta.env.VITE_APP_ENV === 'production' ? 'educaitor' : 'educaitor-staging'),
  /** Store pages, once the app is listed; the join page falls back to "search for EducAitor". */
  appStoreUrl: import.meta.env.VITE_APP_STORE_URL || '',
  playStoreUrl: import.meta.env.VITE_PLAY_STORE_URL || '',
};
